import {
  withTranslation,
} from 'react-i18next';

import RegattaPaymentFieldsView from './RegattaPaymentFieldsView';

const TranslatedComponent = withTranslation()(RegattaPaymentFieldsView);

const Component = TranslatedComponent;

export default Component;
